import React from 'react';
import ReactDOM from 'react-dom/client';
import { initGleap } from './shared/lib/gleap.ts';
import { initSentry } from './shared/lib/sentry.ts';
import App from './App.tsx';
import { worker } from './mocks/browser';
import './index.css';
import { getConfig } from '@/config';

initGleap();
initSentry();
const { VITE_IS_MSW } = getConfig();
// if (process.env.NODE_ENV === 'development') {
if (!!VITE_IS_MSW === true) {
  worker.start();
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
